import { type FC } from "react";
import * as styles from "@root/clientFrontend/features/scout/components/NestedDataMultiSelectModal/styles.css";
import {
  type selectedItemProps,
  type ActionProps,
} from "@root/clientFrontend/features/scout/components/NestedDataMultiSelectModal/modules";

type Props = {
  formState: selectedItemProps;
  dispatchFormState: React.Dispatch<ActionProps>;
};

export const SelectedList: FC<Props> = ({ formState, dispatchFormState }) => {
  return (
    <>
      {Object.entries(formState).map(([parentKey, items]) => (
        <div className={styles.selectedParents} key={parentKey}>
          <div className={styles.selectedParentsNameOuter}>
            <div className={styles.selectedParentsNameInner}>
              <div className={styles.selectedParentsName}>
                <button
                  type="button"
                  className={styles.cancelButton}
                  onClick={() =>
                    dispatchFormState({
                      type: "unSelectParentValue",
                      parentKey,
                    })
                  }
                >
                  <i className="icon-cancel" />
                </button>
                <p className={styles.selectedParentsNameText}>{parentKey}</p>
              </div>
              <ul className={styles.selectedLists}>
                {Object.keys(items).map((key) => (
                  <li className={styles.selectedList} key={key}>
                    <button
                      type="button"
                      className={styles.cancelButton}
                      onClick={() =>
                        dispatchFormState({
                          type: "unSelectValue",
                          parentKey,
                          value: key,
                        })
                      }
                    >
                      <i className="icon-cancel" />
                    </button>
                    {items[key].name}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};
